import { ROUTES } from "@app/constants";
import { PerformanceTile } from "@features/ReportPerformanceMetrics/PerformanceTile";
import { MediaDataStatus, ReportMedia } from "@shared/lib/types/reports";
import { formatData } from "@shared/lib/utils/formatData";
import { Button } from "@shared/ui/Button";
import { Alert, Flex, Space, Typography } from "antd";

const { Title } = Typography;

export function ReportMediaPerformance({
  media,
  inCampaign = false,
}: {
  media: ReportMedia;
  inCampaign?: boolean;
}) {
  return (
    <div style={{ padding: "0 20px", maxWidth: 1200 }}>
      <Title level={inCampaign ? 5 : 3} style={{ marginBottom: 10 }}>
        <Space>
          {!inCampaign ? "Performance" : "Media Analytics"}

          {inCampaign && (
            <Button
              type="link"
              onClick={() =>
                window.open(
                  ROUTES.REPORT_MEDIA.replace(
                    ":reportId",
                    media?.reportId
                  ).replace(":mediaId", media?.reportMediaId)
                )
              }
            >
              View All
            </Button>
          )}
        </Space>
      </Title>

      {media?.mediaDataStatus === MediaDataStatus?.Failed ||
      media?.mediaDataStatus === MediaDataStatus?.Pending ? (
        <Alert
          type={
            media?.mediaDataStatus === MediaDataStatus?.Failed
              ? "error"
              : "info"
          }
          message={
            media?.mediaDataStatus === MediaDataStatus?.Failed ? (
              <div>
                We are unable to fetch the data of this
                <b>
                  <a href={media?.link}> media </a>
                </b>
              </div>
            ) : (
              <div>
                We are fetching the analytics data for this{" "}
                <b>
                  <a href={media?.link}> media </a>
                </b>
                . Please view after sometime
              </div>
            )
          }
        />
      ) : (
        <Flex justify="space-between" style={{ marginTop: 10 }}>
          {inCampaign && (
            <>
              <PerformanceTile
                title="Likes"
                value={`${formatData(media?.mediaData?.likes || 0, "0.0 a")}`}
              />
              <PerformanceTile
                title="Comments"
                value={`${formatData(
                  media?.mediaData?.comments || 0,
                  "0.0 a"
                )}`}
              />
              <PerformanceTile
                title="Views"
                value={`${formatData(media?.mediaData?.views || 0, "0.0 a")}`}
              />
            </>
          )}

          <PerformanceTile
            title="Engagement Rate"
            value={`${formatData(media?.mediaData?.engRate || 0, "0.0 a")}%`}
            infoDesc="The percentage of people who actively engaged with the post after seeing it. Calculated as total engagement divided by total followers."
          />
          <PerformanceTile
            title="Total Engagement"
            value={`${formatData(
              media?.mediaData?.likes ||
                0 + media?.mediaData?.comments ||
                0 + media?.mediaData?.shares ||
                0,
              "0.0 a"
            )}`}
            infoDesc="The total number of interactions or actions taken by users, including likes, comments, and shares."
          />
          <PerformanceTile
            title="Reach"
            value={`${formatData(media?.mediaData?.views || "0.0 a")}`}
            infoDesc="The estimated number of people who have seen this post."
          />
          <PerformanceTile
            title="Impressions"
            value={`${formatData(
              media?.mediaData?.likes ||
                0 + media?.mediaData?.comments ||
                0 + media?.mediaData?.views ||
                0 + media?.mediaData?.shares ||
                0,
              "0.0 a"
            )}`}
            infoDesc="TThe estimated number of times this post has been shown to users."
          />
        </Flex>
      )}
      {/* Add your report media performance content here */}
    </div>
  );
}
